"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceBase_1 = require("./ServiceBase");
var ConstService_1 = require("../consts/ConstService");
var TransportService = (function (_super) {
    __extends(TransportService, _super);
    function TransportService(optios) {
        return _super.call(this, optios) || this;
    }
    TransportService.prototype.updateConfig = function (url) {
        return this.options.baseUrl + "/" + this.domain + "/api/transport/getTransportData";
    };
    TransportService.prototype.transportConfig = function (url, config) {
        if (!config.headers) {
            config.headers = {};
        }
        config.headers['x-real-url'] = url;
        config.headers['x-channel'] = this.options.channel || '';
        return config;
    };
    TransportService.prototype.get = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executeGet(url, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.post = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executePost(url, data, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.delete = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executeDelete(url, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.head = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executeHead(url, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.put = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executePut(url, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.patch = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resultData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.executePatch(url, data, config)];
                    case 1:
                        resultData = _a.sent();
                        if (resultData && resultData.data) {
                            return [2, resultData.data];
                        }
                        return [2, resultData];
                }
            });
        });
    };
    TransportService.prototype.executeGet = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.GET, this.transportConfig(url, config))];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.get(this.updateConfig(url), this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    TransportService.prototype.executePost = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var executeParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        executeParams = {};
                        if (data) {
                            try {
                                executeParams.data = JSON.stringify(data);
                            }
                            catch (error) {
                                console.log('executePost error...', error);
                            }
                        }
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.POST, this.transportConfig(url, config), executeParams)];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.post(this.updateConfig(url), executeParams, this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    TransportService.prototype.executeDelete = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.DELETE, this.transportConfig(url, config))];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.delete(this.updateConfig(url), this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    TransportService.prototype.executeHead = function (url, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.HEAD, this.transportConfig(url, config))];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.head(this.updateConfig(url), this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    TransportService.prototype.executePut = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.PUT, this.transportConfig(url, config), data)];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.put(this.updateConfig(url), data, this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    TransportService.prototype.executePatch = function (url, data, config) {
        if (config === void 0) { config = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.serverFlag && this.serverFlag === ConstService_1.ServiceConst.SERVER_MODE)) return [3, 2];
                        return [4, this.getTransportData(ConstService_1.ServiceConst.PATCH, this.transportConfig(url, config), data)];
                    case 1: return [2, _a.sent()];
                    case 2: return [4, this.apiService.patch(this.updateConfig(url), data, this.transportConfig(url, config))];
                    case 3: return [2, _a.sent()];
                }
            });
        });
    };
    return TransportService;
}(ServiceBase_1.BaseService));
exports.TransportService = TransportService;
//# sourceMappingURL=ServiceTransport.js.map